export default __webpack_public_path__ + "static/media/profileUpdate.fced498c.png";